import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { Typography, Grid } from '@material-ui/core'
import ArrowForwardRoundedIcon from '@material-ui/icons/ArrowForwardRounded'
import { EthStats } from '../../../../../types/stakingPlatform'
import { formatNumber } from '../../../../utils/number'

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    fontWeight: 600,
  },
  card: {
    backgroundColor: 'rgba(0,0,0,0.02)',
    borderRadius: '1rem',
    padding: '2rem !important',
    '& > h6, & > h3': {
      fontWeight: 600,
    },
  },
  trendUp: {
    transform: 'rotate(-45deg)',
  },
  trendDown: {
    transform: 'rotate(45deg)',
  },
  trendContainer: {
    display: 'flex',
    '& *': {
      fontSize: '.9rem',
      fontWeight: 600,
    },
  },
}))

export default function EthStakingStats({
  stakedEth,
  APY,
  stakedEthDollars,
}: EthStats): JSX.Element {
  const classes = useStyles()
  return (
    <Grid container spacing={2} className={classes.root}>
      <Grid item md={8} xs={12} sm={6}>
        <div className={classes.card}>
          <Typography variant="subtitle2" color="textPrimary">
            Total ETH staked
          </Typography>
          <Typography variant="h3">{stakedEth.toLocaleString()} ETH</Typography>
          <Typography variant="subtitle2" color="primary" className={classes.trendContainer}>
            <ArrowForwardRoundedIcon className={classes.trendUp} />
            <span> {`$${stakedEthDollars.toLocaleString()}`} </span>
          </Typography>
        </div>
      </Grid>
      <Grid item md={4} xs={12} sm={6}>
        <div className={classes.card}>
          <Typography variant="subtitle2" color="textPrimary">
            Expected interest rate
          </Typography>
          <Typography variant="h3">{APY}%</Typography>
          {/* <Typography variant="subtitle2" color="primary" className={classes.trendContainer}>
            <ArrowForwardRoundedIcon className={classes.trendUp} /> <span>$123 324 344 24.13</span>
          </Typography> */}
        </div>
      </Grid>
    </Grid>
  )
}
